import React, { useEffect, useMemo, useState } from "react";
import PopupFooter from ".";
import bgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import { Pagination, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "../../../../../utils/hooks";
import bgButtonActive from "../../../../../assets/images/Mini-Game/bg-tab-active-popup.png";
import bgButton from "../../../../../assets/images/Mini-Game/bg-tab-popup.png";
import {
  useDispatch,
  useSelector,
  useMiniGameAuth,
} from "@pages/Events/MiniGame/store";
import { curStateMiniGame } from "../../../../../Redux/selector";
import { getDataSpinHistoryMiniGame } from "../../../../../Redux/futures/mini-game/action";
import _ from "lodash";
import { ID_GIFT_PLAY_LOTO } from "../../../../../helper/const";
import iconGoogluck from "../../../../../assets/images/Event-2026/reel-leaf.png";
import iconAddSpin from "../../../../../assets/images/Event-2026/reel-add-slot.png";
import iconBid from "../../../../../assets/images/Event-2026/reel-bid.png";
import iconTileActivityHis from "../../../../../assets/images/Event-2026/activity history.png";
import arrowLeft from "../../../../../assets/images/Event-2026/arrow-left.png";
import arrowRight from "../../../../../assets/images/Event-2026/arrow-right.png";
import moment from "moment";

const PARAM_HISTORY = {
  all: 0,
  yourHistory: 1,
};

const LIMIT_DATA = 10;
export default function PopupActivityHis({
  isShowPopupHistory,
  setIsShowPopupHistory,
}) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(`(max-width: 486px)`);
  const [isLoader, setIsLoader] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { isAuthenticated } = useMiniGameAuth();
  const statusMiniGame = useSelector(curStateMiniGame)?.configMiniGame;
  // const dataActivityHis =
  //   useSelector(curStateMiniGame)?.dataSpinHistoryMini || {};

  const [dataActivityHis, setDataActivityHis] = useState({});    

  const isLogin = isAuthenticated;
  const [tabActive, setTabActive] = useState(PARAM_HISTORY.all);
  const dispatch = useDispatch();
  const dataTab = [
    {
      id: PARAM_HISTORY.all,
      content: t("mini_game.pop_up_activity_history.all_histories"),
    },
    {
      id: PARAM_HISTORY.yourHistory,
      content: t("mini_game.pop_up_activity_history.your_histories"),
    },
  ];

  const handleGetDataWinner = async () => {
    setIsLoader(true);
    setTimeout(() => {
      setIsLoader(false);
    }, [400]);
  };

  useEffect(() => {
    handleGetDataWinner();
    const data = {
      my_history: tabActive,
      limit: LIMIT_DATA,
      page: currentPage,
      minigame_id: statusMiniGame?.minigame?.id,
    };
    // dispatch(getDataSpinHistoryMiniGame(data));
    dispatch(getDataSpinHistoryMiniGame(data))
        .then((res) => {
          setDataActivityHis(res);
        });    
  }, [tabActive, currentPage]);

  let dataLoader = [];
  for (let i = 0; i < 10; i++) {
    dataLoader = [
      ...dataLoader,
      {
        key: `id_loader_${i}`,
        id: `id_loader_${i}`,
        isdn: "",
        award_id: "",
        num: 0,
        take_time: "",
        name: "",
        image: {
          img: "",
          name: "",
        },
        time: {
          day: "",
          house: "",
        },
      },
    ];
  }

  useEffect(() => {
  }, [dataActivityHis]);

  const formatData = useMemo(() => {
    if (_.isEmpty(dataActivityHis?.resultLast)) {
      return [];
    }

    const handleGetImg = (awardId) => {
      switch (awardId) {
        case ID_GIFT_PLAY_LOTO.good_luck:
          return iconGoogluck;
        case ID_GIFT_PLAY_LOTO.add_spin:
          return iconAddSpin;
        case ID_GIFT_PLAY_LOTO.bid_free:
          return iconBid;
        default:
          break;
      }
    };

    const newData = dataActivityHis?.resultLast?.map((item = {}) => {
      return {
        ...item,
        spin_award_id: item.award_id,
        num: item.award_value,
        take_time: item.spin_time,
        name: item.award_name,
        image: {
          img: item.image || handleGetImg(item.spin_award_id),
          name: item.name ? `${item.award_name || ""} - Piece ${item.name}` : `${+item.award_value || ""} ${item.award_name}`,
        },
        time: {
          day: moment(item.spin_time).local().format("DD/MM/YYYY"),
          house: moment(item.spin_time).local().format("HH:mm:ss"),
        },
      };
    });
    return newData || [];
  }, [dataActivityHis.resultLast]);

  return (
    <div className="popup-minigame__2025 popup-mini-activity-his">
      <PopupFooter
        isOpen={isShowPopupHistory}
        onClose={() => setIsShowPopupHistory(false)}
        className={"popup-activity-history-mini"}
      >
        <>
          <div className="header-mini-popup-rule">
            <div className="content-rule-mini">
              <img src={iconTileActivityHis} alt="" />
            </div>
          </div>

          <div className="mini-tab-popup">
            {dataTab.map((item) => {
              const isDisable =
                item.id === PARAM_HISTORY.yourHistory && !isLogin;

              return (
                <div
                  key={item.id}
                  className={`position-relative tab-mini-popup
                    ${item.id === tabActive ? "tab-popup-active" : ""}
                    ${item.id === 0 ? "tab_left" : "tab_right"}
                    ${isDisable ? "tab-disabled" : ""}`}
                  onClick={() => {
                    if (isDisable) return;

                    setTabActive(item.id);
                    setCurrentPage(1);
                  }}
                >
                  <div className="tab-popup__content tab-btn">
                    {item.content}
                  </div>
                </div>
              );
            })}
          </div>

          <Table
            className="table-winner"
            dataSource={isLoader ? dataLoader : formatData || []}
            pagination={false}
            scroll={{
              y: 365,
            }}
          // rowClassName={highlightRow}
          >
            <Table.Column
              title={t("mini_game.pop_up.prize")}
              dataIndex="image"
              key="image"
              render={(data) => {
                return (
                  <div
                    className="column-prize"
                    style={{
                      minHeight: `${isLoader ? "100px" : ""}`,
                      textAlign: "center",
                    }}
                  >
                    {data?.img ? (
                      <img src={data?.img} alt="prize" height={40} />
                    ) : null}
                    <p className="prize-name">{data?.name}</p>
                  </div>
                );
              }}
            />
            <Table.Column
              title={t("mini_game.pop_up.time")}
              dataIndex="time"
              key="time"
              render={(data) => {
                return (
                  <>
                    <div>{data.day}</div>
                    <div>{data.house}</div>
                  </>
                );
              }}
            />
            <Table.Column
              title={t("mini_game.pop_up.isdn")}
              dataIndex="isdn"
              key="isdn"
            />
          </Table>

          <div className="pagination-popup-his__mini-game">
            <Pagination
              current={currentPage}
              pageSize={10}
              total={dataActivityHis.total}
              onChange={(page) => setCurrentPage(page)}
              showLessItems
              showSizeChanger={false}
              itemRender={(page, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                      className="action-table-mini-game"
                    >
                      <img src={arrowLeft} alt="" />{" "}
                      <span className="action-table-mini-game-content">
                        {t("mini_game.pop_up_activity_history.prev")}
                      </span>
                    </span>
                  );
                }
                if (type === "next") {
                  return (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                      className="action-table-mini-game"
                    >
                      <span className="action-table-mini-game-content">
                        {t("mini_game.pop_up_activity_history.next")}
                      </span>{" "}
                      <img src={arrowRight} alt="" />
                    </span>
                  );
                }
                return originalElement;
              }}
            />
          </div>
        </>
      </PopupFooter>
    </div>
  );
}
